import * as actions from "../actions_agent/Type";
const intialState = {
  create_masruf: {},
  list_masruf: [],
  money_obj: {},
  sell_profit: 0,
  masrufat_view: {},
  list_create_exp: [],
};
const MasrufatReducer = (state = intialState, action) => {
  switch (action.type) {
    case actions.CREATE_MASRUFAT:
      return {
        ...state,
        create_masruf: action.payload,
        list_masruf: [action.payload, ...state.list_masruf],
      };
    case actions.LIST_MASRUFAT:
      return {
        ...state,
        list_masruf: action.payload,
      };
    case actions.DELETE_MASRUFAT:
      return {
        ...state,
        list_masruf: state.list_masruf.filter((el) => el._id !== action.mid),
      };
    case actions.GET_TOTAL_PROFIT_SELL:
      return {
        ...state,
        sell_profit: action.payload,
      };
    case actions.VIEW_MASRUFAT:
      return {
        ...state,
        masrufat_view: action.payload,
      };
    case actions.EXP_LIST_AGENT:
      return {
        ...state,
        list_create_exp: action.payload,
      };
    default:
      return { ...state };
  }
};

export default MasrufatReducer;
